import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../utils/formatNumber';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  handlePagination: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, handlePagination }) => {
  const {t} = useTranslation(); 
  return (
    <div className="flex justify-between items-center mt-6">
      <button
        type='button'
        onClick={() => handlePagination(currentPage - 1)}
        className="px-3 py-2 rounded-md bg-primaryButton text-white disabled:bg-DarkGrey2"
        disabled={currentPage === 1}
      >
        {t('previous')}
      </button>
      {/* <span className="text-sm text-muted">
        page {currentPage} from {totalPages}
      </span> */}
      <span className="text-sm text-muted">
        {t("pagination.pageInfo", {currentPage: formatNumber(currentPage), totalPages:formatNumber(totalPages) })}
      </span>
      <button
      type='button'
        onClick={() => handlePagination(currentPage + 1)}
        className="px-3 py-2 rounded-md bg-primaryButton text-white disabled:bg-DarkGrey2"
        disabled={currentPage === totalPages || currentPage >totalPages}
      >
        {t('next')}
      </button>
    </div>
  );
};

export default Pagination;
